import { toast } from 'react-toastify';

const defaultOptions = {
	position: 'top-center',
	hideProgressBar: false,
	closeOnClick: true,
	draggable: true,
	theme: 'colored',
};

/**
 * Shows a success toast notification
 * @param {string} message - Success message to display
 * @param {object} options - Additional toast options
 */
export const showSuccess = (message, options = {}) => {
	toast.success(message, {
		...defaultOptions,
		autoClose: options.autoClose || 1500,
		pauseOnHover: options.pauseOnHover || false,
		...options,
	});
};

/**
 * Shows an error toast notification
 * @param {string} message - Error message to display
 * @param {object} options - Additional toast options
 */
export const showError = (message, options = {}) => {
	toast.error(message, {
		...defaultOptions,
		autoClose: options.autoClose || 3000,
		pauseOnHover: options.pauseOnHover || true,
		...options,
	});
};

/**
 * Shows a warning toast notification
 * @param {string} message - Warning message to display
 * @param {object} options - Additional toast options
 */
export const showWarning = (message, options = {}) => {
	toast.warning(message, {
		...defaultOptions,
		autoClose: options.autoClose || 3000,
		pauseOnHover: options.pauseOnHover || true,
		...options,
	});
};

